const id = (args: Array<unknown>) => args

const useLogEvent = () => {
    const logEvent = (action: string, properties?: Record<string, string | string[]>) => {
        return id([action, properties])
    }

    return logEvent
}

export const useLogProcessPaymentLoadPage = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string, redirectResult: string | null) => {
        const eventName = 'process payment:load page'
        console.log(eventName)

        logEvent(eventName, {
            paymentReference,
            redirectResult: redirectResult || '',
        })
    }
}

export const useLogProcessPaymentGetPaymentStatus = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'process payment:get payment status'
        console.log(eventName)
        logEvent(eventName, { paymentReference })
    }
}

export const useLogProcessPaymentRedirectToReturnUrl = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'process payment:redirect to return url'
        console.log(eventName)
        logEvent(eventName, { paymentReference })
    }
}

export const useLogProcessPaymentRedirectToRedirectUrl = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'process payment:redirect to redirect url'
        console.log(eventName)
        logEvent(eventName, { paymentReference })
    }
}

export const useLogProcessPaymentPaymentStatusPollingLimitReached = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'process payment:payment status polling limit reached'
        console.log(eventName)
        logEvent(eventName, { paymentReference })
    }
}

export const useLogCardCheckoutLoadPage = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'card checkout:load page'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}

export const useLogCardCheckoutClickBackButton = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'card checkout:click back button'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}

export const useLogCardCheckoutCancelPayment = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string, cancelPaymentRequestType: 'beacon' | 'fetch') => {
        const eventName = 'card checkout:cancel payment'
        console.log(eventName)

        logEvent(eventName, {
            paymentReference,
            cancelPaymentRequestType,
        })
    }
}

export const useLogCardCheckoutAuthorisePayment = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'card checkout:authorise payment'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}

export const useLogCardCheckoutRedirectToReturnUrl = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'card checkout:redirect to return url'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}

export const useLogCardCheckoutRedirectToAction = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'card checkout:redirect to action'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}

export const useLogApplePayCheckoutLoadPage = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'apple pay checkout:load page'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}

export const useLogApplePayCheckoutClickBackButton = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'apple pay checkout:click back button'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}

export const useLogApplePayCheckoutCancelPayment = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string, cancelPaymentRequestType: 'beacon' | 'fetch') => {
        const eventName = 'apple pay checkout:cancel payment'
        console.log(eventName)

        logEvent(eventName, {
            paymentReference,
            cancelPaymentRequestType,
        })
    }
}

export const useLogApplePayCheckoutAuthorisePayment = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'apple pay checkout:authorise payment'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}

export const useLogApplePayCheckoutRedirectToReturnUrl = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'apple pay checkout:redirect to return url'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}

export const useLogApplePayCheckoutRedirectToAction = () => {
    const logEvent = useLogEvent()

    return (paymentReference: string) => {
        const eventName = 'apple pay checkout:redirect to action'
        console.log(eventName)

        logEvent(eventName, { paymentReference })
    }
}
